<template>
  <div id="OdsModal">
    <v-dialog
      v-model="odsModal"
      scrollable
      persistent
      max-width="900"
    >
      <v-card>      
        <v-window
          v-model="odsDetail"
        >
          <!-- ODS Grid -->
          <v-window-item :value="100">
            <v-card-title>
              <v-layout row wrap align-center justify-end>
                <v-flex xs10 sm6>
                  <v-img :lazy-src="`@/dist/loading.gif`" :src="require('@/assets/images/ODS/ODS Logo.png')"></v-img>
                </v-flex>
                <v-flex xs2 offset-sm2 sm1 class="text-xs-right">
                  <v-btn icon @click="close">
                    <v-icon color="grey">close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-title>

            <v-container grid-list-xs>
              <v-layout row wrap align-center justify-start>
                <v-flex xs3 sm2 class="pa-2 ods-image" v-for="(ods, idx) in ods" :key="idx">
                  <v-img :lazy-src="`@/dist/loading.gif`" :src="ods.image" @click="odsSelected(idx)"></v-img>
                </v-flex>            
              </v-layout>
            </v-container>
          </v-window-item>

          <!-- ODS Detail -->
            <v-window-item v-for="(ods, idx) in ods" :key="idx" :value="idx"> 
              <!-- Header -->
              <v-card-title class="pa-0">
                <v-img :lazy-src="`@/dist/loading.gif`" :src="ods.svg" v-if="odsDetail === idx">
                  <v-layout row wrap fill-height align-center justify-space-between>
                      <v-btn 
                        icon 
                        :class="{
                          'ml-0' : screenWidthXS,
                          'ml-4' : screenWidthSM || screenWidthMD || screenWidthLG || screenWidthXL,
                          }" 
                        @click="arrowBack"
                      >
                        <v-icon class="white--text">arrow_back</v-icon>
                      </v-btn>                    
                      <v-btn 
                        icon 
                        :class="{
                          'mr-0' : screenWidthXS,
                          'mr-4' : screenWidthSM || screenWidthMD || screenWidthLG || screenWidthXL,
                          }" 
                        @click="close"
                      >
                        <v-icon class="white--text">close</v-icon>
                      </v-btn>
                  </v-layout>                    
                </v-img>
              </v-card-title>
              
              <!-- Content -->
              <v-card-text style="height: 400px; overflow-y: scroll;">
                <v-container grid-list-xs class="pb-0">
                  <v-layout row wrap justify-space-around align-end>
                    <v-flex xs12>
                      <div v-html="ods.description"></div>                      
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>      

              <!-- Button -->
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="white"
                  class="pink--text mx-4 mb-2"
                  flat
                  :href="ods.link"
                  target="_blank"
                >
                  Más Info
                </v-btn> 
              </v-card-actions>      
            </v-window-item>
        </v-window>
      </v-card>
    </v-dialog> 
  </div>
</template>

<script>
import { eventBus } from '@/main.js'

export default {
  name: 'ods-modal',
  props: ['odsModal','odsDetail','screen'],
  mounted () {
    this.getOds()
  },
  data: () => ({    
    ods: [],
  }),
  computed: {
    screenWidthXS() {
      return this.screen.width < 600 ? true : false
    },
    screenWidthSM() {
      return this.screen.width > 600 && this.screen.width < 960 ? true : false
    },
    screenWidthMD() {
      return this.screen.width > 960 && this.screen.width < 1264 ? true : false
    },
    screenWidthLG() {
      return this.screen.width > 1264 && this.screen.width < 1904 ? true : false
    },
    screenWidthXL() {
      return this.screen.width > 1904 ? true : false
    },
  },
  methods: {
    close() {
      eventBus.$emit('odsModalDisplay', false)
    },
    arrowBack() {
      eventBus.$emit('odsDetailChange', 100)
    },
    odsSelected(idx) {
      eventBus.$emit('odsClicked', idx)
    },
    getOds() {
      this.$http
        .get(
          "/ods",
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            }
          }
        )
        .then(response => {
          this.ods = response.data.data;
        });
    },
  }, 
}
</script>
